import * as React from 'react'
import classNames from 'classnames'
import Header from './Header'
import { ITitleAndDescription } from './interface'
import './TitleAndDescription.scss'

const TitleAndDescription = ({
  className,
  description,
  htmlSectionHeadingLevel,
  spanTextAtTheEnd,
  subDescription,
  title
}: ITitleAndDescription): JSX.Element => (
  <div className={classNames('TitleAndDescription', className)}>
    <Header className='TitleAndDescription__title' level={htmlSectionHeadingLevel} title={title} />
    {description ? (
      <p className='TitleAndDescription__description'>
        {description}
        {spanTextAtTheEnd ? <span>{spanTextAtTheEnd}</span> : null}
      </p>
    ) : null}
    {subDescription ? <p className='TitleAndDescription__description'>{subDescription}</p> : null}
  </div>
)

export default TitleAndDescription
